import React from 'react';
import PropTypes from 'prop-types';
import { Tabs, Tab } from 'react-bootstrap';
import { withRouter } from 'react-router';

import { OVERVIEW_MENU, WEB_MENU, IOS_MENU, ANDROID_MENU } from '../core/MenuComponent/MenuConstants';
import DeveloperSdkComponent from './developerSdk/DeveloperSdkComponent';
import ScrollToTop from '../../ScrollToTop';
import ScrollButtonComponent from '../core/ScrollButtonComponent/ScrollButtonComponent';

import './developerApi.scss';

class DeveloperApiComponent extends React.Component {
    changeApi = (api) => this.props.history.push(`/api/${api}`)

    getMenuItems = (api, menuItems) => Object.keys(menuItems).map((keyItem) => {
        const menuItem = menuItems[keyItem];
        const { params } = this.props.match;
        const subMenu = menuItem && menuItem.subMenu;

        return {
            ...menuItem,
            url: `/api/${api}/${keyItem}`,
            active: params.menuItem === keyItem,
            subMenu: subMenu && Object.keys(subMenu).map((subMenuItem) => ({
                ...subMenu[subMenuItem],
                url: subMenuItem,
                active: params.subMenuItem === subMenuItem,
            })),
        };
    })

    renderTab(api, title, menu) {
        return <Tab eventKey={api} title={title}>
            <DeveloperSdkComponent
                menuTitle={title}
                menuItems={this.getMenuItems(api, menu)}
            />
        </Tab>;
    }

    render() {
        const { tab } = this.props;

        return <div id="developer-api" className="Developer-api-component">
            <ScrollToTop elementId="developer-api" indentElementId="header">
                <Tabs onSelect={this.changeApi} defaultActiveKey={tab} id="api-tabs">
                    <Tab title="DOCS" eventKey="docs" />
                    {this.renderTab('overview', 'Overview', OVERVIEW_MENU)}
                    {this.renderTab('web', 'Web API', WEB_MENU)}
                    {this.renderTab('ios', 'iOS API', IOS_MENU)}
                    {this.renderTab('android', 'Android API', ANDROID_MENU)}
                </Tabs>
            </ScrollToTop>
            <ScrollButtonComponent elementId="developer-api" />
        </div>;
    }
}

DeveloperApiComponent.defaultProps = {
    tab: 'overview',
};

DeveloperApiComponent.propTypes = {
    tab: PropTypes.string.isRequired,
    history: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
};

export default withRouter(DeveloperApiComponent);



// WEBPACK FOOTER //
// ./src/components/developerApi/DeveloperApiComponent.js